import React, { useEffect, useState } from "react";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { getAllApplications, setApplicationsUseAlternativeURL } from "../../../helpers/api";
import { Row, Col, Form } from "react-bootstrap";

export default function ApplicationSettingsPage() {

  const [applicationsConfig, setApplicationsConfig] = useState({"applications":[]});
  const [updateApplicationsConfig, setUpdateApplicationsConfig] = useState(true);

  useEffect(()=>{
      getAllApplications().then((data)=>{
        setApplicationsConfig(data);
      }).catch((e)=>{
        console.log(e);
      });
  },[updateApplicationsConfig]);

  const createApplicationItem = (applications, onChange) => {
    return applications.map((app) => (
      <Row
        key={app.id}
        className="align-items-center border-bottom py-2"
        style={{ marginBottom: "5px" }}
      >
        <Col xs={6}>
          <strong>{app.title || app.tittle}</strong>
        </Col>
        <Col xs={6}>
          <Form.Select
            value={app.useAlternative ? "true" : "false"}
            onChange={(e) => onChange(app.id, e.target.value === "true")}
          >
            <option value="true">True</option>
            <option value="false">False</option>
          </Form.Select>
        </Col>
      </Row>
    ));
  };


  return (
    <>
      <PrettyContainer tittle="APPLICATIONS URL SETTINGS">{createApplicationItem(applicationsConfig.applications, (appId, useAlternative) => {
              setApplicationsUseAlternativeURL({appId:appId, useAlternative:useAlternative}).then(()=>{
                setUpdateApplicationsConfig(!updateApplicationsConfig);
              }).catch(()=>{
                setUpdateApplicationsConfig(!updateApplicationsConfig);
              });
            })}
      </PrettyContainer>
    </>
  );
}
